import { CollectionViewer, DataSource } from '@angular/cdk/collections';

import { ApiService } from '../../core/upgraded-providers';

import {
    Observable,
    BehaviorSubject
} from 'rxjs';

export class ResourceOrdersDataSource implements DataSource<any> {
    private _dataSubject = new BehaviorSubject<any[]>([]);

    constructor(
        private _apiService: ApiService
    ) {
    }

    connect(collectionViewer: CollectionViewer): Observable<any[]> {
        return this._dataSubject.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this._dataSubject.complete();
    }

    getData({
        shard,
        resourceType
    }): Promise<any> {
        const queries = [];

        const orders = this._apiService
            .get('game/market/orders', { shard, resourceType })
            .then(({ list }) => {
                const sellList = list.filter(({ type }) => type === 'sell');
                const buyList = list.filter(({ type }) => type === 'buy');

                return { sellList, buyList };
            });
        queries.push(orders);

        const stats = this._apiService
            .get('game/market/stats', { shard, resourceType })
            .then(({ stats }) => stats);
        queries.push(stats);

        if (shard) {
            const worldSize = this._apiService
                .get('game/world-size', { shard })
                .then(({ width, height }) => ({ width, height }));
            queries.push(worldSize);
        }

        return Promise.all(queries)
            .then(([{ sellList, buyList }, statsList, worldSize]) => {
                return { sellList, buyList, statsList, worldSize };
            });
    }
}
